const state = {
  campaignVoiceList: [],
};

export default state;
